<template>
	<div>
		<Fontnavbar title="订单列表"/>
		<div class="order-success">
			<van-icon name="checked" size="100" />
			<div class="order-tip">下单成功</div>
		</div>
		<div class="order-btn">
			<van-button round block type="primary">订单详情</van-button>
		</div>
		<div class="order-btn">
			<van-button round block type="default">继续购物</van-button>
		</div>
	</div>
</template>

<script>
import {
	Icon,
	Button
} from 'vant'
import Fontnavbar from "../../components/Navbar.vue";
export default {
	components: {
		[Icon.name]: Icon,
		[Button.name]: Button,
		Fontnavbar
	},
	
  data() {
    return {
			imgDomain: process.env.VUE_APP_IMG_URL
    };
  },
	
	mounted () {
		
	},

  methods: {
		goPage(path) {
			this.$router.push({path: path});
		}
		
  }
	
}

</script>

<style lang="less" scoped>
.order-success{
	padding: 40px;
	text-align: center;
	color: #07c160;
}
.order-tip{
	font-size: 14px;
}
.order-btn{
	margin: 10px 20px;
}
</style>
